import './IconLanding.css'

const IconLanding = () => (
  <svg
    className="w-full"
    width="496"
    height="315"
    viewBox="0 0 496 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.10962 311.238L492.447 311.238"
      stroke="#222629"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M275.528 289.839L272.528 256.139H223.128L220.128 289.839C219.428 297.639 214.728 305.139 207.328 311.139V311.239H288.328V311.139C280.928 305.139 276.228 297.639 275.528 289.839Z"
      fill="#BFCFE2"
    />
    <path
      opacity="0.28"
      d="M223.128 256.139L221.328 276.339H274.328L272.528 256.139H223.128Z"
      fill="#1F3969"
      stroke="#1F3969"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M275.528 289.839L272.528 256.139H223.128L220.128 289.839C219.428 297.639 214.728 305.139 207.328 311.139V311.239H288.328V311.139C280.928 305.139 276.228 297.639 275.528 289.839Z"
      stroke="#222629"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M405.828 261.139H89.8282C83.2282 261.139 77.8282 255.739 77.8282 249.139V43.1387C77.8282 36.5387 83.2282 31.1387 89.8282 31.1387H405.828C412.428 31.1387 417.828 36.5387 417.828 43.1387V249.139C417.828 255.839 412.428 261.139 405.828 261.139Z"
      fill="white"
    />
    <path
      d="M405.828 261.139H89.8282C83.2282 261.139 77.8282 255.739 77.8282 249.139V43.1387C77.8282 36.5387 83.2282 31.1387 89.8282 31.1387H405.828C412.428 31.1387 417.828 36.5387 417.828 43.1387V249.139C417.828 255.839 412.428 261.139 405.828 261.139Z"
      fill="#BFCFE2"
    />
    <path
      d="M405.828 261.139H89.8282C83.2282 261.139 77.8282 255.739 77.8282 249.139V43.1387C77.8282 36.5387 83.2282 31.1387 89.8282 31.1387H405.828C412.428 31.1387 417.828 36.5387 417.828 43.1387V249.139C417.828 255.839 412.428 261.139 405.828 261.139Z"
      stroke="#222629"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M400.884 222.766L400.884 48.166L94.8839 48.166L94.8839 222.766L400.884 222.766Z"
      fill="#3A3A3A"
    />
    <path
      opacity="0.28"
      d="M105.828 48.166V170.668C105.828 174.557 109.428 177.739 113.828 177.739H302.928C307.328 177.739 310.928 174.557 310.928 170.668V48.166H105.828Z"
      fill="#C4C4C4"
      fillOpacity="0.25"
    />
    <path
      d="M400.884 222.766L400.884 48.166L94.8839 48.166L94.8839 222.766L400.884 222.766Z"
      stroke="#222629"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M234.428 241.838H261.328"
      stroke="#222629"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M311.928 166.738H114.828L114.828 2.53711C114.828 2.53711 110.428 2.53823 114.828 2.53823L319.928 2.53925V158.838C319.928 163.238 316.328 166.738 311.928 166.738Z"
      fill="#C4C4C4"
    />
    <path
      d="M319.928 166.737H116.828C115.724 166.737 114.828 165.842 114.828 164.737L114.828 4.53515C114.828 3.43058 115.724 2.53516 116.828 2.53516L317.928 2.53547C319.033 2.53547 319.928 3.4309 319.928 4.53547V166.737Z"
      stroke="#C4C4C4"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.28"
      d="M410.628 202.136H294.628C290.228 202.136 286.628 198.536 286.628 194.136V71.2363C286.628 66.8363 290.228 63.2363 294.628 63.2363H410.628C415.028 63.2363 418.628 66.8363 418.628 71.2363V194.136C418.628 198.636 415.028 202.136 410.628 202.136Z"
      fill="#2D425E"
    />
    <path
      d="M418.628 195.136H302.628C298.228 195.136 294.628 195.022 294.628 190.622V64.2363C294.628 59.8363 294.298 56.2363 298.698 56.2363H421.459C425.859 56.2363 426.628 56.3723 426.628 60.7723V190.622C426.628 195.122 423.028 195.136 418.628 195.136Z"
      fill="#2AA1FF"
    />
    <path
      d="M426.628 192.137C426.628 193.794 425.285 195.137 423.628 195.137H297.628C295.971 195.137 294.628 193.794 294.628 192.137L294.628 59.2363C294.628 57.5795 295.971 56.2363 297.628 56.2363H423.628C425.285 56.2363 426.628 57.5795 426.628 59.2363V192.137Z"
      stroke="#2D425E"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.34"
      d="M401.328 94.3367H319.728C316.828 94.3367 314.528 92.0367 314.528 89.1367V81.3367C314.528 78.4367 316.828 76.1367 319.728 76.1367H401.328C404.228 76.1367 406.528 78.4367 406.528 81.3367V89.1367C406.528 92.0367 404.228 94.3367 401.328 94.3367Z"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g opacity="0.34">
      <path
        opacity="0.34"
        d="M365.528 123.636H319.928C317.028 123.636 314.728 121.336 314.728 118.436V110.636C314.728 107.736 317.028 105.436 319.928 105.436H365.528C368.428 105.436 370.728 107.736 370.728 110.636V118.436C370.628 121.336 368.328 123.636 365.528 123.636Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M401.428 123.636H383.728C380.828 123.636 378.528 121.336 378.528 118.436V110.636C378.528 107.736 380.828 105.436 383.728 105.436H401.428C404.328 105.436 406.628 107.736 406.628 110.636V118.436C406.628 121.336 404.328 123.636 401.428 123.636Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M314.628 154.037H406.528"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M314.628 164.838H406.528"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M314.628 175.637H370.628"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M134.928 21.1387C137.137 21.1387 138.928 19.3478 138.928 17.1387C138.928 14.9295 137.137 13.1387 134.928 13.1387C132.719 13.1387 130.928 14.9295 130.928 17.1387C130.928 19.3478 132.719 21.1387 134.928 21.1387Z"
      fill="#FF5F5A"
    />
    <path
      d="M148.828 21.1387C151.037 21.1387 152.828 19.3478 152.828 17.1387C152.828 14.9295 151.037 13.1387 148.828 13.1387C146.619 13.1387 144.828 14.9295 144.828 17.1387C144.828 19.3478 146.619 21.1387 148.828 21.1387Z"
      fill="#FFBE2E"
    />
    <path
      d="M162.728 21.1387C164.937 21.1387 166.728 19.3478 166.728 17.1387C166.728 14.9295 164.937 13.1387 162.728 13.1387C160.519 13.1387 158.728 14.9295 158.728 17.1387C158.728 19.3478 160.519 21.1387 162.728 21.1387Z"
      fill="#2ACA44"
    />
    <path
      d="M232.628 44.2363H245.628"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M166.728 44.2363H223.028"
      stroke="#7BFFA0"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.928 44.2363H158.728"
      stroke="#9169FF"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.728 142.736H207.728"
      stroke="#9169FF"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.928 142.736H152.828"
      stroke="#7BFFA0"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M223.028 56.5371H231.128"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.228 56.5371H213.428"
      stroke="#9169FF"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M148.828 56.5371H176.528"
      stroke="#FFC47D"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M191.728 68.8379H215.628"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M161.728 68.8379H184.228"
      stroke="#FF5757"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.928 81.1387H199.828"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M175.128 81.1387H186.228"
      stroke="#9169FF"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M148.828 81.1387H166.728"
      stroke="#7BFFA0"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.228 93.5371H219.128"
      stroke="#FFC47D"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M148.828 93.5371H177.428"
      stroke="#FF5757"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M224.128 105.838H241.428"
      stroke="#9169FF"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.228 105.838H214.928"
      stroke="#FF5757"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M161.728 105.838H177.428"
      stroke="#7BFFA0"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M199.828 118.139H214.928"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M161.728 118.139H189.428"
      stroke="#9169FF"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M239.128 130.438H256.428"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.228 130.438H229.728"
      stroke="#FFC47D"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M148.828 130.438H176.528"
      stroke="white"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconLanding
